import { render, staticRenderFns } from "./Denominations.vue?vue&type=template&id=a347fefc&"
import script from "./Denominations.vue?vue&type=script&lang=ts&"
export * from "./Denominations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports